import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useStockCheckDetailModel } from "./stockCheckDetailsModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, cm } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { addDesc, lookDesc, editDesc } = useStockCheckDetailModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics: IDescription[] = [
        {
            label: Locale["System Inventory"],//"系统库存",
            value: typeDesc[mode].stockAll.toFixed(0),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Real Inventory"],//"实际库存",
            value: typeDesc[mode].checkAll.toFixed(0),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Surplus Item Number"],//"盘盈项数",
            value: typeDesc[mode].SurplusNumAll.toFixed(0),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Loss Item Number"],//"盘亏项数",
            value: typeDesc[mode].deficitNumAll.toFixed(0),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Difference Qty"],//"差异数量",
            value: typeDesc[mode].differenceNumAll.toFixed(0),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Difference Amount"],//"差异金额",
            value: typeDesc[mode].differenceMoneyAll.toFixed(2),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: Locale["Qty Difference Rate"],//"数量差异率",
            value: isNaN(typeDesc[mode].differenceRateNumAll) ? "0%" : Math.abs(typeDesc[mode].differenceRateNumAll).toFixed(0) + "%",
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Amount Difference Rate"],//"金额差异率",
            value: isNaN(typeDesc[mode].differenceRateAll) ? "0%" : Math.abs(typeDesc[mode].differenceRateAll).toFixed(0) + "%",
            color: DescriptionColorEnum.green,
            status: true
        },
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}